import Vue from 'vue'
import Vuex from 'vuex'
import user from '@/modules/user'
import notifications from '@/modules/notifications'
import loader from '@/modules/loader'
import event from '@/modules/event'
import checkout from '@/modules/checkout'
import plan from '@/modules/plan'
import order from '@/modules/order'
import affiliation from '@/modules/affiliation'
import VuexPersistence from 'vuex-persist'
import VueClipboard from 'vue-clipboard2'


Vue.use(Vuex)
Vue.use(VueClipboard)

// MÓDULOS PARA ALMACENAMIENTO EN CACHÉ
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['user']
})

// MÓDULOS DE VUEX
export default new Vuex.Store({
  modules: {
    user, notifications, event, plan, checkout, loader, order, affiliation
  },
  plugins: [vuexLocal.plugin]
})
